"use strict";
var headerEl = document.getElementById('header');
var headerAdjustEl = document.getElementById('header-adjust');
var showAfterEl = document.querySelector('[data-hide-header-until-after-scroll]');
var hideHeader = function () {
    headerEl.classList.remove('active');
};
var hideHeaderAdjust = function () {
    headerAdjustEl.style.display = 'none';
};
var showHeader = function () {
    headerEl.classList.add('active');
};
var showHeaderAdjust = function () {
    headerAdjustEl.style.display = 'block';
};
var checkForHeaderReveal = function () {
    if (!headerEl.classList.contains('active') && window.pageYOffset > showAfterEl.offsetTop + showAfterEl.offsetHeight) {
        showHeader();
    }
    else if (headerEl.classList.contains('active') && window.pageYOffset < showAfterEl.offsetTop) {
        hideHeader();
    }
};
// ensure idempotency for this method because it will be called many times
var initHeader = function () {
    // don't initialize header if no headerEl exists (prevent errors in this function when '?showContentOnly=true' is present in url)
    if (!headerEl)
        return;
    hideHeader();
    hideHeaderAdjust();
    if (showAfterEl && window.innerWidth >= window.breakpoints.large) {
        window.removeEventListener('scroll', checkForHeaderReveal);
        window.addEventListener('scroll', checkForHeaderReveal);
    }
    else {
        showHeader();
        showHeaderAdjust();
    }
};
// set a throttle to reinit after resize
var headerResizeTimer;
var resetHeaderResizeTimer = function () {
    clearTimeout(headerResizeTimer);
    headerResizeTimer = setTimeout(initHeader, 100);
};
// init now and on resize
initHeader();
window.addEventListener('resize', resetHeaderResizeTimer);
